// compontents
import StepperItem, { StepperItemProps } from './stepper-item/stepper-item'

// styles
import styles from './stepper.module.scss'

type StepperProps = {
	steps?: StepperItemProps[]
} & React.HTMLAttributes<HTMLDivElement>

const Stepper = (props: StepperProps): JSX.Element => {
	const {
		className,
		steps = [
			{ label: 'Upload Photo' },
			{ label: 'Delta V' },
			{ label: 'BMR' },
			{ label: 'NBA' },
		],
		...attr
	} = props

	return (
		<>
			{steps && steps.length > 0 && (
				<div
					{...attr}
					className={[styles.stepper, className].join(' ').trim()}
				>
					<nav>
						<ul>
							{steps.map((step, index) => {
								return (
									<StepperItem
										key={index}
										{...step}
										index={index + 1}
									/>
								)
							})}
						</ul>
					</nav>
				</div>
			)}
		</>
	)
}

export default Stepper
